import React, { Fragment } from 'react';
import JoinCoupon from './JoinCoupon/JoinCoupon';
import CouponDiscount from './CouponDiscount/CouponDiscount';
import CardBenefit from './CardBenefit/CardBenefit';
// import PointBenefit from './PointBenefit/PointBenefit';
import DeliveryInfo from './DeliveryInfo/DeliveryInfo';
import SalesPeriod from './SalesPeriod/SalesPeriod';
import SellerShop from './SellerShop/SellerShop';
import HotelBenefit from './HotelBenefit/HotelBenefit';
import RefundInfo from './RefundInfo/RefundInfo';
import ReservationInfo from './ReservationInfo/ReservationInfo';
import IdenticalProduct from './IdenticalProduct/IdenticalProduct';

function TopInfo() {
  const { isEndSale } = TMON.htStaticData;

  return (
    <Fragment>
      <CouponDiscount />
      <JoinCoupon />
      <CardBenefit />
      {/* <PointBenefit /> */}
      <IdenticalProduct />
      <DeliveryInfo />
      {!isEndSale && <SalesPeriod />}
      <SellerShop />
      <HotelBenefit />
      <RefundInfo />
      <ReservationInfo />
    </Fragment>
  );
}

export default TopInfo;
